import { render } from "./EmailBuilderPage.vue?vue&type=template&id=f49f5f9a"
import script from "./EmailBuilderPage.vue?vue&type=script&lang=js"
export * from "./EmailBuilderPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__